import { render, staticRenderFns } from "./ServiceList.vue?vue&type=template&id=9f7ecfc6&scoped=true&"
import script from "./ServiceList.vue?vue&type=script&lang=js&"
export * from "./ServiceList.vue?vue&type=script&lang=js&"
import style0 from "./ServiceList.vue?vue&type=style&index=0&id=9f7ecfc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7ecfc6",
  null
  
)

export default component.exports